
define('template!webshopProductsCategoriesListCategoryView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(category) { ;
__p += '\n  <div class="chip';
 if(category.copied) { ;
__p += ' copied';
 } ;
__p += '" title="' +
__e( category.name ) +
' - ' +
__e( texts.copy ) +
'">\n    <div class="code">' +
__e( category.code ) +
'</div>\n    <div class="remove" title="' +
__e( texts.remove ) +
'">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>\n    </div>\n  </div>\n';
 } else if(loaded && free) { ;
__p += '\n  <div class="empty">\n    <input type="text" class="search" autocomplete="off" spellcheck="false" placeholder="' +
__e( texts.add ) +
'"/>\n    ';
 if(clipboard && !clipboard.alreadyIn) { ;
__p += '\n      <div class="paste" title="' +
__e( texts.paste ) +
' ' +
__e( clipboard.code ) +
'">\n        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-35.3 28.7-64 64-64h128V80c0-26.5-21.5-48-48-48H279.4C268.4 12.9 247.7 0 224 0H160zM128 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H256z"/></svg>\n      </div>\n    ';
 } ;
__p += '\n  </div>\n';
 } ;
__p += '\n<div class="loader-2"></div>\n';

}
return __p
};});

